import { Component } from '@angular/core';
import { FieldFormComponent } from '../field-form/fieldform.component';

@Component({
    selector: 'm4u-fieldx',
    templateUrl: './fieldformx.component.html',
    styleUrls: ['./fieldformx.component.scss']
})
export class FieldFormComponentX extends FieldFormComponent {

}